 <template>
    <div>
        <div>
            <el-form :model="$parentInfo.dialog_UpdateTeacher.teacher" :label-position="'right'" label-width="50px" >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="编号">
                            <el-input v-model="$parentInfo.dialog_UpdateTeacher.teacher.id"
                                      placeholder="请输入姓名"
                                      disabled
                                      style="width: 200px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="姓名">
                            <el-input v-model="$parentInfo.dialog_UpdateTeacher.teacher.name"
                                      placeholder="请输入姓名"
                                      style="width:200px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="账号">
                            <el-input v-model="$parentInfo.dialog_UpdateTeacher.teacher.email"
                                      placeholder="无账号"
                                      style="width: 200px"
                                      disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="电话">
                            <el-input v-model="$parentInfo.dialog_UpdateTeacher.teacher.phone"
                                      placeholder="无电话"
                                      style="width: 200px"
                                      ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学科">
                            <el-select v-model="$parentInfo.dialog_UpdateTeacher.teacher.subject_id"
                                       placeholder="请选择"
                                       style="width: 200px">
                                <el-option
                                        v-for="item in $parentInfo.dialog_UpdateTeacher.subjects"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="类型">
                            <el-select v-model="$parentInfo.dialog_UpdateTeacher.teacher.introducation"
                                       placeholder="请选择"
                                       style="width: 200px">
                                <el-option
                                        v-for="item in $parentInfo.introducations"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态">
                            <el-select v-model="$parentInfo.dialog_UpdateTeacher.teacher.status"
                                       placeholder="请选择"
                                       style="width: 200px">
                                <el-option
                                        v-for="item in $parentInfo.status_type"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="备注">
                            <el-input v-model="$parentInfo.dialog_UpdateTeacher.teacher.remark"
                                      placeholder="请输入备注"
                                      type="textarea"
                                      :rows="2"
                                      style="width: 500px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="可参与学期" label-width="100">
                            <el-checkbox-group v-model="$parentInfo.dialog_UpdateTeacher.teacher_semesters">
                                <el-table
                                        :data="$parentInfo.dialog_UpdateTeacher.semesters"
                                        border
                                        style="width: 100%">
                                    <el-table-column prop="semesterType_name" label="学期" width="180"></el-table-column>
                                    <el-table-column v-for="(item, index) in $parentInfo.dialog_UpdateTeacher.semesters[0].section_data" :key="index">
                                        <template slot="header" slot-scope="scope">
                                            {{item.section_name}}
                                        </template>
                                        <template slot-scope="scope">
                                            <el-checkbox :disabled="scope.row.section_data[index].disabled" :label="scope.row.section_data[index].id" >{{scope.row.section_data[index].name}}</el-checkbox>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleUpdateTeacher"
                       :loading="$parentInfo.dialog_UpdateTeacher.button_loading">修 改
            </el-button>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Dialog_UpdateTeacher",
        data () {
            return {
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShow();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleShow(){
                this.$wApi.send(this.$parentInfo.path, 'get_teacher_detail',{
                    'teacher_id':this.$store.state.modal.data.teacher_id,
                });
            },
            handleUpdateTeacher(){
                this.$parentInfo.dialog_UpdateTeacher.button_loading=true
                this.$wApi.send(this.$parentInfo.path, 'update_teacher',{
                    'teacher':this.$parentInfo.dialog_UpdateTeacher.teacher,
                    'teacher_semesters':this.$parentInfo.dialog_UpdateTeacher.teacher_semesters,
                });
            }
        }
    }
</script>

<style scoped>

</style>